import { CheckCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { ConfigProvider, Dropdown } from "antd";
import type { MenuProps } from "antd";
import {
  DoneControl,
  DoneLabel,
  MarkDoneButton,
  MoreButton,
  ResetItem,
  ResetSubtitle,
  ResetTitle,
} from "./style";

interface SetStatusCellProps {
  isDone: boolean;
  updating?: boolean;
  onMarkDone: () => void;
  onReset: () => void;
}

export default function SetStatusCell({
  isDone,
  updating,
  onMarkDone,
  onReset,
}: SetStatusCellProps) {
  if (!isDone) {
    return (
      <ConfigProvider wave={{ disabled: true }}>
        <MarkDoneButton loading={updating} onClick={onMarkDone}>
          Mark as Done
        </MarkDoneButton>
      </ConfigProvider>
    );
  }

  const menuItems: MenuProps["items"] = [
    {
      key: "reset",
      label: (
        <ResetItem vertical gap={1}>
          <ResetTitle>Reset Status</ResetTitle>
          <ResetSubtitle>Undo the &ldquo;Mark as Done&rdquo; change</ResetSubtitle>
        </ResetItem>
      ),
      onClick: onReset,
    },
  ];

  return (
    <ConfigProvider wave={{ disabled: true }}>
      <DoneControl align="center">
        <DoneLabel align="center" gap={6}>
          <CheckCircleOutlined />
          Done
        </DoneLabel>
        <Dropdown
          menu={{ items: menuItems }}
          trigger={["click"]}
          placement="bottomRight"
          disabled={updating}
        >
          <MoreButton loading={updating} icon={<MoreOutlined />} />
        </Dropdown>
      </DoneControl>
    </ConfigProvider>
  );
}
